import { Reveal, Overline } from "./Reveal";
import { SERVE } from "../lib/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {SERVE.map((s) => (
      <span key={s} className="flex items-center">
        <span className="font-serif text-4xl sm:text-6xl text-zinc-700 px-8 whitespace-nowrap hover:text-gold-foil transition-colors duration-300">
          {s}
        </span>
        <span className="h-2 w-2 rounded-full bg-amber-500/50" />
      </span>
    ))}
  </div>
);

export const WhoWeServe = () => (
  <section id="serve" className="relative bg-[#221b14] py-24 sm:py-32 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 mb-12">
      <Reveal>
        <Overline>Who We Serve</Overline>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl max-w-2xl leading-[1.05]">
          We proudly partner with those{" "}
          <span className="text-gold-foil">ready to grow.</span>
        </h2>
      </Reveal>
    </div>

    <div className="relative flex overflow-hidden py-6 select-none [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
      <div className="flex animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  </section>
);
